var React = require('react');

function Slash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M636.63 480.55L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.81 22.45z","className":"fa-secondary","key":1})]);
}

Slash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Slash;

Slash.default = Slash;
